import { useEffect, useState } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  useEffect(() => {
    if (open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const el = document.createElement("textarea");
      el.value = url;
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
      } catch {
        /* ignore */
      }
      document.body.removeChild(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭分享"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/55"
      />
      <div className="relative w-full max-w-md rounded-lg bg-background-50 p-6">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-share-forward-line text-primary-700" />
            分享《{title}》
          </h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-background-300/70 text-foreground-700"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <p className="mt-3 text-sm text-foreground-600">
          复制下方链接，把它分享给同样喜欢影视的朋友吧。
        </p>

        <div className="mt-4 flex items-center gap-2 rounded-md border border-background-300/70 bg-background-100/70 px-3 py-2.5">
          <i className="ri-link text-foreground-500" />
          <span className="flex-1 truncate text-xs text-foreground-700">{url}</span>
        </div>

        <button
          type="button"
          onClick={copy}
          className={`mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-semibold transition-colors ${
            copied
              ? "bg-secondary-500 text-background-50"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          <i className={copied ? "ri-check-line" : "ri-file-copy-line"} />
          {copied ? "链接已复制" : "复制链接"}
        </button>
        <p className="mt-3 text-center text-xs text-foreground-400">分享为演示功能，不会真实发送。</p>
      </div>
    </div>
  );
}